import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import React from 'react';

export default function SkeletonUserInfoLayout() {
  const theme = useTheme();

  return (
    <Box
      width={1}
      bgcolor={theme.palette.common.white}
      borderRadius={8}
      height={500}
    >
      &nbsp;
    </Box>
  );
}
